import { render, staticRenderFns } from "./AddCompanyAddress.vue?vue&type=template&id=648ede26&scoped=true&"
import script from "./AddCompanyAddress.vue?vue&type=script&lang=js&"
export * from "./AddCompanyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ede26",
  null
  
)

export default component.exports